import React from "react";
import * as Shared from "../components/CivicShared";
const { NotFound } = Shared;
export default function NotFoundPage(props) { return <NotFound {...props} />; }
